import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/terminalUiRelease/importer/releaseImporterActions';

export default importerReducers(actions);
